module.exports = [
  { id: 'twitter', name: 'Twitter', windowSize: [600, 300] },
  { id: 'facebook', name: 'Facebook', windowSize: [555, 625] },
  { id: 'pinterest', name: 'Pinterest', windowSize: [750, 750] },
  { id: 'email', name: 'Email' }
]
